import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:검색조건 없음
 * 세부설명:
*/

export class NoResult extends Component {
    static displayName = NoResult.name;

    constructor(props) {
        super(props);
        this.state = {
        };
        this.Count = 0;
    }
    //초기화
    componentDidMount() {
        this.Count++;
    }
    componentWillUnmount() {
        
    } 
    
    render() {
        if (this.props.Visible === undefined) {
            return false;
        }
        else {
            if (this.Count>0 && this.props.Visible === true) {
                return (
                    <div className="recent_product result_box">
                        <div className="no_result" style={{ top: this.props.Top === undefined ? "50%" : this.props.Top }}>
                            <div className="icon"></div>
                            <div className="text">검색결과가 없습니다.</div>
                        </div>
                    </div>
                );
            }
        }
        
    }
}
